;(function () {
  angular
    .module('contrast.protect.rules')
    .controller(
      'ModalBlockAtPerimeterModalCtrl',
      ModalBlockAtPerimeterModalCtrl
    )

  function ModalBlockAtPerimeterModalCtrl(
    $scope,
    $q,
    $uibModalInstance,
    $translate,
    ProtectionRulesFactory,
    logger,
    promiseConfigs,
    withLogging
  ) {
    'ngInject'

    angular.extend($scope, {
      confirm: confirm,
      cancel: cancel
    })

    function confirm() {
      var promises = [],
        i,
        config

      for (i = 0; i < promiseConfigs.length; i++) {
        config = promiseConfigs[i]
        promises.push(
          ProtectionRulesFactory.editEnvProtectionLevel(
            config.appId,
            config.ruleId,
            config.env,
            config.level
          )
        )
      }

      $q.all(promises)
        .then(function () {
          $uibModalInstance.close()
          if (withLogging) {
            logger.logSuccess(
              $translate.instant('detail_protectionPolicyUpdatedSuccessfully')
            )
          }
        })
        .catch(function () {
          $uibModalInstance.dismiss()
          if (withLogging) {
            logger.logError(
              $translate.instant('detail_protectionPolicyNotUpdated')
            )
          }
        })
    }

    function cancel() {
      $uibModalInstance.dismiss(false)
    }
  }
})()
